<template>
  <div class="container-fluid">
    <div class="row">
      <div class="form-group col-lg-12">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          label="CLI_DSC"
          :getOptionLabel="client => client.CLI_ID + ' - ' + client.CLI_DSC"
          :options="clients"
          v-model="clientSelected"
          :initial-value="clientSelected"
          :reduce="client => client.CLI_ID"
          v-validate="'required'"
          :hasErrors="errors.has('client')"
        />

        <small v-show="errors.has('client')" class="form-text">
          {{ errors.first('client') }}
        </small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-12" :class="{ 'has-error': errors.has('tag_name') }">
        <label for="tag_name">{{ $t('tag_name') }}</label>
        <input
          type="text"
          id="tag_name"
          name="tag_name"
          class="form-control"
          :placeholder="$t('ph_tag_name')"
          v-model="tag_name"
          v-validate="'required'"
        >
        <small v-show="errors.has('tag_name')" class="form-text text-muted">
          {{ errors.first('tag_name') }}
        </small>
      </div>
    </div>

    <div class="row">
      <LoaderButton
        class="ml-3"
        @click="save"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import LoaderButton from '@/components/button/LoaderButton'
import { mapState } from 'vuex'

export default {
  name: 'RemoteIDADD',
  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      clientSelected: undefined,
      tag_name: ''
    }
  },

  computed: {
    ...mapState({
      clients: state => state.arena.clients
    })
  },

  methods: {
    async save() {
      const { dispatch } = this.$store

      const isValid = await this.$validator.validateAll()

      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))

        return dispatch('notify/error', err)
      }

      await dispatch('arena/addRemoteID', {
        client: this.clientSelected,
        tagName: this.tag_name
      })
    }
  },

  async mounted () {
    await this.$store.dispatch('arena/fetchClients')
  },
}

</script>
